<script lang="ts" setup>
import Dropdown from '@/Components/App/Dropdown.vue'
import DropdownLink from '@/Components/App/DropdownLink.vue'
import { useTeams } from '@/Support/Teams/Composables/useTeams'

const emit = defineEmits<{
  (e: 'selected'): void
}>()

const { currentTeam, allTeams, switchToTeam } = useTeams(emit)
</script>

<template>
  <Dropdown align="right" width="60">
    <template #trigger>
      <span class="inline-flex rounded-md w-full justify-center">
        <button
          class="inline-flex items-center px-3 py-2 text-base lg:text-sm leading-4 font-medium rounded-md text-neutral-900 dark:text-neutral-100 lg:text-neutral-100 bg-white/0 hover:bg-white/10 focus:bg-white/30 dark:focus:bg-white/20 active:bg-neutral-50 transition"
          type="button"
        >
          {{ currentTeam.name }}

          <svg
            class="ml-2 -mr-0.5 h-4 w-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              fill-rule="evenodd"
            />
          </svg>
        </button>
      </span>
    </template>

    <template #content>
      <div class="lg:w-60">
        <!-- Organization Management -->
        <div
          class="block px-4 py-2 text-xs text-neutral-500 dark:text-neutral-400"
        >
          {{ __('Manage Organization') }}
        </div>

        <!-- Organization Settings -->
        <DropdownLink :href="route('public.app.teams.show')">
          {{ __('Organization Settings') }}
        </DropdownLink>

        <DropdownLink preserve-state :href="route('public.app.teams.create')">
          {{ __('Create New Organization') }}
        </DropdownLink>

        <div class="border-t border-neutral-100 dark:border-neutral-700" />

        <!-- Organization Switcher -->
        <div
          class="block px-4 py-2 text-xs text-neutral-600 dark:text-neutral-400"
        >
          {{ __('Switch Organizations') }}
        </div>

        <div class="max-h-64 overflow-y-auto">
          <template v-for="team in allTeams" :key="team.id">
            <form @submit.prevent="switchToTeam(team)">
              <DropdownLink as="button">
                <div class="flex items-center">
                  <svg
                    v-if="team.id === currentTeam.id"
                    class="mr-2 h-5 w-5 text-green-400"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div class="truncate">{{ team.name }}</div>
                </div>
              </DropdownLink>
            </form>
          </template>
        </div>
      </div>
    </template>
  </Dropdown>
</template>
